import { ReportLevel } from "../adminReportsApiSlice";
import { LessonUsageBarChart } from "../shared/LessonUsageBarChart";

// Required property for the chart
interface LessonUsageRequiredBase {
	totalMinutes: number;
}

export function LessonUsageByCategoryChart<T extends LessonUsageRequiredBase>(props: {
	level: ReportLevel;
	data: T[];
	hasData: boolean;
	yAxisDataField: keyof T;
	title: string;
}) {
	return (
		<LessonUsageBarChart
			data={props.data}
			hasData={props.hasData}
			title={props.title}
			yAxisDataField={props.yAxisDataField}
			seriesName="Total Time Spent"
			yAxisLabelWidth={325}
		/>
	);
}
